export const AMOUNT_TYPE = {
  PAID: "PAID",
  DUE: "DUE",
  TOTAL: "TOTAL",
} as const;

export const FILTER_KEY = {
  SOURCES: "SOURCES",
  MIN_AMOUNT_PAID: "MIN_AMOUNT_PAID",
  MAX_AMOUNT_PAID: "MAX_AMOUNT_PAID",
  MIN_AMOUNT_DUE: "MIN_AMOUNT_DUE",
  MAX_AMOUNT_DUE: "MAX_AMOUNT_DUE",
  MIN_TOTAL_INVOICED: "MIN_TOTAL_INVOICED",
  MAX_TOTAL_INVOICED: "MAX_TOTAL_INVOICED",
  HAS_OVERDUE: "HAS_OVERDUE",
  NO_OUTSTANDING_DUE: "NO_OUTSTANDING_DUE",
  NO_PAYMENTS: "NO_PAYMENTS",
} as const;

export const FILTER_TYPE = {
  SOURCES: "SOURCES",
  AMOUNT_PAID: "AMOUNT_PAID",
  AMOUNT_DUE: "AMOUNT_DUE",
  TOTAL_INVOICED: "TOTAL_INVOICED",
  OTHERS: "OTHERS",
} as const;

export const LABEL = {
  AMOUNT_PAID: "Amount Paid",
  AMOUNT_DUE: "Amount Due",
  TOTAL_INVOICED: "Total Invoiced Amount",
  OVERDUE_INVOICES: "Overdue invoices",
  OVERDUE_INVOICES_CHIP: "Overdue Invoices",
  NO_OUTSTANDING_DUE: "No outstanding due",
  NO_PAYMENTS: "No payments yet",
  SOURCES: "Sources",
  OTHERS: "Others",
  MIN_PREFIX: "Min.",
  MAX_PREFIX: "Max.",
} as const;

export const CURRENCY_PREFIX = "$";
